import yosubscriptionsjs from '@yola/yosubscriptionsjs';
import yousersjs from '@yola/yousersjs';
import { configure } from '@yola/subscription-manager-js';
import Configuration from '../../configuration';

const configureSubscriptionsManager = async () => {
  const config = Configuration.get();
  const origin = config.getPublicApiUrl();

  configure({
    subscriptionService: yosubscriptionsjs({ origin }),
    partnerService: yousersjs.partner(),
  });
};

export default configureSubscriptionsManager;
